/* eslint-disable */
/* tslint:disable */
import { Pagination } from 'antd'
import { useEffect, useState } from 'react'
import { JuryList } from '../../../data/jury'

const pageSize = 12
const totalCount =
  JuryList.length % pageSize === 0
    ? JuryList.length / pageSize
    : JuryList.length / pageSize + 1

// JuryList.sort(function compareFunc(item1, item2) {
//   return item1.name.localeCompare(item2.name)
// })
// console.log(2222, JuryList)

const JuryCardA = () => {
  const [pageNo, setPageNo] = useState(1)
  const [data, setData] = useState([])
  const [totalPage, setTotalPage] = useState(totalCount)
  const [totalNums, setTotalNums] = useState(JuryList.length)

  useEffect(() => {
    window.scrollTo(0, 0)
    const startIndex = (pageNo - 1) * pageSize
    const endIndex = pageNo * pageSize
    setData(JuryList.slice(startIndex, endIndex) as any)
  }, [pageNo])

  return (
    <>
      <div className="jury-div-cards-info">
        {data.map((item: any, index) => {
          return (
            <div className="jury-item">
              <div className="jury-div-cardItem">
                <div className="jury__header">
                  {/* <img src={header} /> */}
                  <img src={item.imgSrc} />
                </div>
                <div className="cover">
                  <div className="cover-zhName">{item.name}</div>
                  <div className="cover-company"> {item.company} </div>
                  <div className="cover-title"> {item.title} </div>
                  <div className="cover-info">
                    <div style={{ overflow: 'auto', maxHeight: '419px' }}>
                      {' '}
                      {item.info}{' '}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
      <div className="pagination">
        {totalPage > 1 && (
          <Pagination
            current={pageNo}
            onChange={setPageNo}
            pageSize={pageSize}
            total={totalNums}
            showSizeChanger={false}
          />
        )}
      </div>
    </>
  )
}

export default JuryCardA
